import once from "@drupal/once";
import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from "swiper/modules"

import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/effect-fade"

export default class Quotes {

  constructor(selector) {
    const elements = once('quotes', selector);
    elements.forEach(element => {
      const slides = element.querySelectorAll('.swiper-slide');
      if (slides.length > 1) {
        const swiper = new Swiper(element.querySelector('.swiper-quotes'), {
          modules: [Pagination, EffectFade, Autoplay],
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'slider-quotes-bullet',
            bulletActiveClass: 'slider-quotes-bullet-active',
          },
          effect: "fade",
          fadeEffect: { crossFade: true },
          slidesPerView: 1,
          speed: 1000,
          autoplay: {
            delay: 6000,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
          },
          autoHeight: false,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          }
        });
      }

    });


  }

}
